/**
 * @file Codes for the languages supported in the application.
 */

/**
 * Valid i18n language codes for the application.
 */
const LanguageCodes = {
  EN: 'en',
  FR: 'fr',
};

export default LanguageCodes;
